import { r as registerInstance, h, g as getElement, H as Host } from './index-16dc7dde.js';
import { c as classnames } from './index-136476ff.js';
import { p as pesIconSizes, a as pesIconMirrorDirection } from './constants-e9ddcc22.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import './lookups-705fb53e.js';
import { I as ICONS_BY_TYPE } from './all-products-8182e14d.js';
import './request.constants-deb285e0.js';
import { s as send, j as productSelectorVirtualPageEvent } from './send-33ade633.js';
import { i as isAnalyticsEnabled } from './helpers-71d81730.js';
import './_commonjsHelpers-ba3f0406.js';
import './isTypedArray-dfccd669.js';
import './isObject-33fa1780.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';

const actionBlockCss = ".action-block{box-sizing:border-box;flex:1;min-height:130px;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;padding:0 28px}.action-block *,.action-block *::before,.action-block *::after{box-sizing:inherit}.action-block--small .action-block__heading,.action-block--small .action-block__text{font-size:13px;line-height:15px}.action-block__heading{font-size:16px;line-height:25px;margin:0 0 8px;color:#333333;text-align:center;max-width:100%}.action-block__text-content{background:none;color:#42b4e6;border:none;padding:0;cursor:pointer;outline:inherit;font-family:inherit;font-size:15px;line-height:20px;font-weight:normal;text-align:center}.action-block__text-content:hover{text-decoration:underline}.action-block__text-content:hover{text-decoration:none}.action-block__text{display:inline;text-transform:capitalize}.action-block:hover .action-block__text{text-decoration:underline}.action-block__text-arrow-icon{display:inline-flex;align-items:center;height:20px;width:20px;vertical-align:middle;position:relative;bottom:1px}:host(:not([dir=\"rtl\"])) .action-block__text-arrow-icon{left:2px}:host([dir=\"rtl\"]) .action-block__text-arrow-icon{right:2px;transform:scaleX(-1)}";

let ActionBlock = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.icon = 'segment_retail';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("pes-banner", { url: this.url, icon: this.icon }, h("div", { class: classnames('action-block', { 'action-block--small': this.size === 'small' }) }, h("h3", { class: "action-block__heading", innerHTML: this.heading }), h("span", { class: "action-block__text-content" }, h("span", { class: "action-block__text", innerHTML: this.text }), h("pes-icon", { class: "action-block__text-arrow-icon", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")))));
  }
  get el() { return getElement(this); }
};
ActionBlock.style = actionBlockCss;

let ProductSelector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.opened = false;
    this.renderActionBlock = () => (h("pes-action-block", { heading: this.actionBlock.label, text: this.actionBlock.linkText, icon: ICONS_BY_TYPE[this.actionBlock.type], onClick: this.handleClick }));
    this.handleClick = () => {
      this.opened = true;
      if (isAnalyticsEnabled()) {
        send(productSelectorVirtualPageEvent);
      }
    };
    this.handleLoaderClick = () => {
      this.opened = false;
    };
  }
  openProductSelector() {
    if (!this.opened || !this.selectorConfig || !this.selector) {
      return;
    }
    if (this.selectorConfig.type === 'sc') {
      const host = document.createElement('pdp-sc-selector-modal');
      const frame = document.createElement('div');
      frame.id = 'widgetFrame';
      host.headerLabel = this.selectorConfig.scLabel || 'Select your product';
      host.appendChild(frame);
      host.open = true;
      host.addEventListener('didClose', () => {
        document.body.removeChild(host);
        this.opened = false;
      });
      document.body.appendChild(host);
    }
    this.selector.open(this.getSelectorConfig());
  }
  getSelectorConfig() {
    var _a;
    return Object.assign(Object.assign({}, this.selectorConfig), { scOptions: !isEmpty_1((_a = this.actionBlock.selectorConfig) === null || _a === void 0 ? void 0 : _a.scOptions)
        ? this.actionBlock.selectorConfig.scOptions
        : {} });
  }
  render() {
    return (h(Host, null, h("se-loading", { loading: this.opened && !this.selectorConfig, onClick: this.handleLoaderClick, fullPage: true, overlay: true }), this.selectorConfig ? (h("pes-product-selector", { config: this.getSelectorConfig(), renderFunction: (selector) => {
        this.selector = selector;
        return this.renderActionBlock();
      } })) : (this.renderActionBlock())));
  }
  static get watchers() { return {
    "opened": ["openProductSelector"],
    "selectorConfig": ["openProductSelector"],
    "selector": ["openProductSelector"]
  }; }
};

export { ActionBlock as pes_action_block, ProductSelector as pes_action_block_product_selector };
